export function statCard(icon: string, value: string | number, label: string, subValue?: string) {
  const card = document.createElement('div');
  card.className = 'stat-card';
  const subHtml = subValue && subValue.trim() ? '<div class="stat-subvalue">' + subValue + '</div>' : '';

  card.innerHTML =
    '<div style="font-size: 1.5rem; margin-bottom: 10px;">' +
    icon +
    '</div>' +
    '<span class="stat-value">' +
    String(value) +
    '</span>' +
    subHtml +
    '<div class="stat-label">' +
    label +
    '</div>';
  return card;
}

